import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Optional } from "@/__main__/data-model.mjs";

export const player = {
  accountId: String,
  name: Optional(String),
  updatedAt: Date,
  anonymous: Boolean,
} satisfies ModelDefinition;

export const playerModelValidation = createModel(player);

const validateFn = createModel({
  data: {
    player,
  },
}).transform(player, (response) => response.data.player);

export type Player = FromModel<typeof validateFn>;

export default validateFn;
